/**
 * Componente funcional que renderiza una tarjeta de contacto para emergencias técnicas.
 * * Muestra opciones de contacto directo mediante teléfono, WhatsApp y correo electrónico
 * específicamente para incidentes críticos que afecten la operación.
 * * @component
 * @example
 * return (
 * <EmergencyInfo />
 * )
 * * @returns {JSX.Element} Un contenedor con la información de soporte de Central TI.
 */
const EmergencyInfo = () => {
  const phone = '70416418'
  const email = 'soporte@grupomecsa.net'
  const whatsapp = '50670416418'

  const telHref = 'tel:' + phone
  const waHref = 'https://wa.me/' + whatsapp
  const mailHref = 'mailto:' + email

  return (
    <div className="p-3">
      <div className="d-flex align-items-center gap-2 mb-2">
        <i className="fa-solid fa-triangle-exclamation text-danger"></i>
        <h6 className="mb-0 fw-semibold text-danger">¿Es una emergencia?</h6>
      </div>

      <p className="text-body-secondary small mb-3">
        Para incidentes críticos que detengan la operación, contacte
        directamente a central TI.
      </p>

      <a
        href={telHref}
        className="d-flex align-items-center gap-2 mb-2 text-decoration-none text-body small"
      >
        <i className="fa-solid fa-phone text-primary" style={{ width: 16 }}></i>
        <span className="fw-medium">7041-6418</span>
      </a>

      <a
        href={waHref}
        target="_blank"
        rel="noopener noreferrer"
        className="d-flex align-items-center gap-2 mb-2 text-decoration-none text-body small"
      >
        <i
          className="fa-brands fa-whatsapp"
          style={{ color: '#25D366', width: 16 }}
        ></i>
        <span className="fw-medium">7041-6418</span>
      </a>

      <a
        href={mailHref}
        className="d-flex align-items-center gap-2 text-decoration-none text-body small"
      >
        <i
          className="fa-solid fa-envelope text-primary"
          style={{ width: 16 }}
        ></i>
        <span className="fw-medium text-truncate">{email}</span>
      </a>
    </div>
  )
}

export default EmergencyInfo
